import { render, staticRenderFns } from "./PosContent.vue?vue&type=template&id=1276f654&scoped=true"
import script from "./PosContent.vue?vue&type=script&lang=js"
export * from "./PosContent.vue?vue&type=script&lang=js"
import style0 from "./PosContent.vue?vue&type=style&index=0&id=1276f654&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1276f654",
  null
  
)

export default component.exports